<template>
    <div class="uik-widget-content__wrapper uik-widget-content__grey">
        <div :class="{
            'uik-widget__wrapper':true,
            'uik-widget__padding': padding
        }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "UikWidget",
    props: {
        padding: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-widget__wrapper {
  border: $borderDefault;
  box-shadow: $boxShadow;
  border-radius: 4px;
  background: #FFFFFF;
  display: block;
  &.uik-widget__padding {
    padding: 30px;
  }
  &.uik-widget__margin {
    margin: 15px;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 500;
  }
  h3 {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

/* Widget Table */
.uik-widget-table__wrapper {
  width: 100%;
  border-collapse: collapse;
  tr {
    td,
    th {
      text-align: left;
      padding: 15px 15px;
      border-bottom: $borderDefault;
      line-height: 1.5;
      &:first-child {
        padding-left: 30px;
      }
      &:last-child {
        padding-right: 30px;
      }
    }
    th {
      font-weight: 500;
      font-size: .75rem;
      padding: 8px 15px;
      text-transform: uppercase;
      color: $textSecondary;
      line-height: 1.125rem;
      height: 44px;
      align-items: center;
    }
    td {
      font-size: .875rem;
      height: 70px;
      padding: 0 inherit;
      color: $textMain;
    }
  }
}
</style>
